import ApiService from './common/API.service'

export interface MailConfigRequest {
  host: string
  port: number
  secure: boolean
  authUser: string
  // Omit to keep the currently saved password unchanged; only required for first-time setup.
  authPass?: string
  fromAddress: string
}

export type MailConfigResponse = Omit<MailConfigRequest, 'authPass'>

export type MailProvider = 'ses' | 'smtp'

export interface MailConfigStatus {
  mailProvider: MailProvider
  configured: boolean
  host?: string
  port?: number
  secure?: boolean
  authUser?: string
  fromAddress?: string
}

export class MailConfigService extends ApiService {
  putMailConfig = async (payload: MailConfigRequest): Promise<MailConfigResponse> => {
    const { data } = await this.put<MailConfigRequest, MailConfigResponse>(
      this.buildCommonUrl('mail-config'),
      payload
    )
    return data
  }

  getStatus = async (): Promise<MailConfigStatus> => {
    const { data } = await this.get<MailConfigStatus>(this.buildCommonUrl('mail-config'))
    return data
  }

  setProvider = async (enabled: boolean): Promise<{ mailProvider: MailProvider }> => {
    const { data } = await this.put<{ enabled: boolean }, { mailProvider: MailProvider }>(
      this.buildCommonUrl('mail-config/provider'),
      { enabled }
    )
    return data
  }

  sendTestEmail = async (to: string): Promise<{ ok: boolean }> => {
    const { data } = await this.post<{ to: string }, { ok: boolean }>(
      this.buildCommonUrl('mail-config/test'),
      { to }
    )
    return data
  }
}
